import { render, staticRenderFns } from "./support.vue?vue&type=template&id=bdec77d6&"
import script from "./support.vue?vue&type=script&lang=js&"
export * from "./support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdec77d6')) {
      api.createRecord('bdec77d6', component.options)
    } else {
      api.reload('bdec77d6', component.options)
    }
    module.hot.accept("./support.vue?vue&type=template&id=bdec77d6&", function () {
      api.rerender('bdec77d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/support.vue"
export default component.exports